// @flow

import { type PendingIncomingPayment } from './types';

export function getQRCodeImage(incomingPayment: PendingIncomingPayment): string {
  const ewallet = incomingPayment.ewallet;
  if (!ewallet || !ewallet.qr_code_image) {
    throw new Error('QR code image is not available');
  }

  return ewallet.qr_code_image;
}

export function getQRCodeValue(incomingPayment: PendingIncomingPayment): string {
  const ewallet = incomingPayment.ewallet;
  if (!ewallet || !ewallet.qr_code_value) {
    throw new Error('QR code value is not available');
  }

  return ewallet.qr_code_value;
}
